import * as React from "react";
import { Box } from "@mui/material";

import { colors } from "../../assets/colors";
import SettingsConfig from "./SettingsConfig/SettingsConfig";

export default function TabsContainer({ currentWiidth }: any) {
  return (
    <Box className="controller-wrapper">
      <Box
        sx={{
          borderBottom: 1,
          backgroundColor: colors.dark,
          borderColor: "transparent",
          borderTopLeftRadius: 12,
          borderTopRightRadius: 12,
        }}
        style={{ width: "360px" }}
      >
        <div
          style={{
            height: "35px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <label>STREAM LINK</label>
        </div>
      </Box>

      <Box className="streamSettings">
        <SettingsConfig currentWiidth={currentWiidth} />
      </Box>

      <Box
        sx={{
          borderBottom: 32,
          backgroundColor: colors.dark,
          borderColor: "black",
          borderBottomLeftRadius: 12,
          borderBottomRightRadius: 12,
        }}
      />
    </Box>
  );
}
